import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";

const FeaturedOnHeading = ({ title = "Featured On", subtitle }) => {
  const isMobile = useMediaQuery("(max-width: 600px)");

  const lineWidth = isMobile ? "120px" : "250px";

  const leftLineSx = {
    width: lineWidth,
    height: 0,
    borderTop: "2.5px solid",
    borderImageSlice: 1,
    borderImageSource: "linear-gradient(90deg, rgba(201, 224, 137, 0.08) 0%, rgba(98, 131, 9, 0.4) 100%)",
  };

  const rightLineSx = {
    ...leftLineSx,
    borderImageSource: "linear-gradient(90deg, rgba(98, 131, 9, 0.4) 0%, rgba(201, 224, 137, 0.08) 100%)",
  };

  return (
    <Box
      sx={{
        width: "94.44%",
        maxWidth: "1440px",
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        mt: isMobile ? "10px" : "0px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: isMobile ? "10px" : "18px",
          width: "100%",
        }}
      >
        <Box sx={leftLineSx} />
        <Typography
          sx={{
            fontFamily: "Nunito, sans-serif",
            fontWeight: 700,
            fontSize: isMobile ? "16px" : "22px",
            lineHeight: isMobile ? "16px" : "18px",
            color: "#8EA946",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Typography>
        <Box sx={rightLineSx} />
      </Box>

      {subtitle ? (
        <Typography
          sx={{
            mt: isMobile ? "18px" : "18px",
            // fontFamily: "Red Hat Display",
            fontWeight: 800,
            fontSize: isMobile ? "16px" : "24px",
            lineHeight: "100%",
            letterSpacing: "0%",
            textAlign: "center",
            verticalAlign: "middle",
            textTransform: "capitalize",
            color: "#1D1D1B",
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
};

export default FeaturedOnHeading;

